<template>
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    x="0"
    y="0"
    viewBox="0 0 86 86"
    xml:space="preserve"
    :class="[size]"
  >
    <g>
      <path
        class="st0"
        d="M34.16 71.93h-3.52c-2.54 0-4.92-.99-6.71-2.78a9.424 9.424 0 0 1-2.78-6.71c0-1.35 1.1-2.45 2.45-2.45s2.45 1.1 2.45 2.45c0 1.22.48 2.37 1.34 3.24.87.87 2.02 1.34 3.24 1.34h3.52c2.53 0 4.59-2.06 4.59-4.59s-2.06-4.59-4.59-4.59c-1.35 0-2.45-1.1-2.45-2.45s1.1-2.45 2.45-2.45c2.53 0 4.59-2.06 4.59-4.59s-2.06-4.59-4.59-4.59h-3.52c-1.22 0-2.38.48-3.24 1.34-.87.87-1.34 2.02-1.34 3.24 0 1.35-1.1 2.45-2.45 2.45s-2.45-1.09-2.45-2.45c0-2.54.99-4.92 2.78-6.71a9.418 9.418 0 0 1 6.7-2.78h3.52c5.23 0 9.49 4.26 9.49 9.49 0 2.79-1.21 5.3-3.13 7.04a9.479 9.479 0 0 1 3.13 7.04c.01 5.25-4.25 9.51-9.48 9.51z"
      />
      <path
        class="st0"
        d="M82.44 86H3.47C1.58 86 .04 84.46.04 82.57V14.16c0-1.89 1.54-3.43 3.43-3.43h78.96c1.89 0 3.43 1.54 3.43 3.43v68.41A3.42 3.42 0 0 1 82.44 86zM4.95 81.1h76.02V15.63H4.95V81.1zm77.49-65.47z"
      />
      <path
        class="st0"
        d="M83.42 33.22H2.49c-1.35 0-2.45-1.1-2.45-2.45s1.1-2.45 2.45-2.45h80.92c1.35 0 2.45 1.1 2.45 2.45s-1.09 2.45-2.44 2.45zM69.34 22.67c-1.35 0-2.45-1.1-2.45-2.45V2.63c0-1.35 1.1-2.45 2.45-2.45s2.45 1.1 2.45 2.45v17.59c0 1.35-1.09 2.45-2.45 2.45zM16.57 22.67c-1.35 0-2.45-1.1-2.45-2.45V2.63c0-1.35 1.1-2.45 2.45-2.45s2.45 1.1 2.45 2.45v17.59c0 1.35-1.1 2.45-2.45 2.45zM58.79 71.93c-1.35 0-2.45-1.1-2.45-2.45V47.24l-2.85 2.85c-.96.96-2.51.96-3.46 0-.96-.96-.96-2.51 0-3.46l7.04-7.04c.7-.7 1.75-.91 2.67-.53.92.38 1.51 1.27 1.51 2.26v28.15a2.471 2.471 0 0 1-2.46 2.46z"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: "CalendarIcon",
  props: {
    size: {
      type: String,
      default: "medium",
      validator: function (value) {
        // The value must match one of these strings
        return ["small", "medium", "large", "xxlarge"].includes(value);
      },
    },
  },
};
</script>

<style scoped>
.st0 {
  fill: #619bc4;
}
.medium {
  height: 24px;
  width: auto;
}
.large {
  height: 60px;
  width: auto;
}
.xxlarge {
  height: 84px;
  width: auto;
}
</style>
